import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Route } from 'react-router-dom';
import { Provider } from 'mobx-react';
import devtools from '@tiger/devtools';
import App from 'modules/App';
import { ErrorBoundary } from 'utils/bugsnag/client';

devtools({
    smart: true,
    tool: 'all'
});

ReactDOM[__SSR__ ? 'hydrate' : 'render'](
    <ErrorBoundary>
        <Provider>
            <BrowserRouter basename={process.env.BASE_NAME || '/'}>
                <Route path="/" component={App} />
            </BrowserRouter>
        </Provider>
    </ErrorBoundary>,
    document.getElementById('wrap')
);
